export default "__VITE_ASSET__CtFAhvMb__"